import { isValidPhoneNumber } from 'react-phone-number-input/input'
import * as Yup from 'yup'

export const validationSchema = ({
  required,
  invalid,
}: {
  required: string
  invalid: string
}) =>
  Yup.object().shape({
    phone: Yup.string()
      .required(required)
      .test('isValid', invalid, (val) => isValidPhoneNumber(`+${val}`)),
  })
